<template>
  <v-col
    class="d-none d-lg-flex bg-image"
    cols="12"
    md="5"
    :style="{ backgroundImage: `url(${image})` }"
  >
  </v-col>
</template>

<script>
import { locals } from "@/helpers/locals";

export default {
  name: "left-side-image",
  data() {
    return {
      settings: null,
      image: null,
      imageRatio: 0.7077,
      imageLength: 0,
      idImage: 0,
    };
  },
  created() {
    this.interval = setInterval(() => {
      try {
        this.settings = locals.getLocal("settings");
        this.idImage =
          locals.getLocal("idImage") != null ? locals.getLocal("idImage") : 0;
      } catch (e) {
        console.log(e);
      }

      if (this.settings != null) {
        clearInterval(this.interval);

        this.settings.config.forEach((value) => {
          if (value.key === "left_image") {
            this.imageLength = value.value.length;
            if (this.idImage === this.imageLength) {
              this.idImage = 0;
            }
            this.image = value.value[this.idImage].value;
            this.loadImageRatio(this.image);
            this.idImage += 1;
            locals.setLocal("idImage", this.idImage);
          }
        });
      }
    }, 0);
  },
  methods: {
    loadImageRatio(url) {
      if (!url) {
        return;
      }
      const img = new Image();
      img.onload = () => {
        if (img.naturalWidth && img.naturalHeight) {
          this.imageRatio = img.naturalWidth / img.naturalHeight;
          document.documentElement.style.setProperty(
            "--left-image-ratio",
            String(this.imageRatio)
          );
        }
      };
      img.src = url;
    },
  },
};
</script>

<style>
.bg-image {
  background-color: #00205b;
  background-position: left top;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0 !important;
}
</style>
